(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/bankid/same-device.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/bankid/same-device.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.player_login.views.bankid.SameDevice = Marionette.View.extend({
    template: function template(data) {
      return svs.player_login.templates.dummy(data);
    },
    behaviors: [{
      behaviorClass: svs.player_login.behaviors.BankIDErrorHandling
    }],
    isNativeApp: svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isNativeApp') ? svs.core.config.data.svsconfig.isNativeApp : false,
    onAttach: function onAttach() {
      var _this = this;

      svs.player_login.radio.request('autoStartToken', true).done(function (autoStartToken) {
        _this.model.set('autoStartToken', autoStartToken);

        svs.player_login.router.navigate("/poll?".concat(_this.model.toQueryString('bankid')), true);
      }).fail(function (err) {
        _this.triggerMethod('bankIDError', err);
      });
    }
  });
})(Backbone, _, svs);
 })(window);